<template>
  <div class="container">
    <div v-html="content"></div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      content: ''
    }
  },
  async mounted() {
    const query = qs.parse(location.search.replace('?', '')) || {}
    const contentType = query.ct
    let res = await this.$deliverer.fetchSingleAdContent(contentType, {
      appKey: query.ak || '',
      'tm-useragent-productversion': query.v || '',
      'tm-useragent-deviceos': query.p || ''
    })
    this.content = res.data.configValue.content
    document.title = res.data.configValue.title
  }
}
</script>

<style lang="scss">
.container {
  padding: 10px 20px;
  * {
    font-family: PingFang TC, sans-serif !important;
  }
  table.ne-table {
    word-break: break-all;
    width: auto !important;
    td {
      border: 1px solid #d9d9d9;
      padding: 5px;
    }
  }
  ul,ol {
    list-style-position: inside;
    padding-inline-start: 20px;
  }
}
</style>
